import React from 'react';
import './CheckCircle.css';

interface ICheckCircleProps {
  className?: string;
  checkColor?: string;
}

const CheckCircle: React.FC<React.PropsWithChildren<ICheckCircleProps>> = ({
  className = '',
  checkColor = 'text-white',
}) => {
  return (
    <svg
      className={`CheckCircle ${className}`}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 52 52"
    >
      <circle
        className="CheckCircle-circle"
        cx="26"
        cy="26"
        r="25"
        fill="none"
      />
      <path
        className={`CheckCircle-check ${checkColor}`}
        fill="none"
        d="M14.1 27.2l7.1 7.2 16.7-16.8"
      />
    </svg>
  );
};
export default CheckCircle;
